module.exports = __webpack_public_path__ + "img/img0.c458e068.jpg";